<template>
  <div class="enterprise">
    <div v-if="$store.state.brandMoudle.activeName === '0'" class="header clearBoth">
      <span class="title">Enterprise</span>
      <span class="amount" @click="toEnterprise">View all {{ $parent.$parent.result.enterprise.totalRecords }} search results >></span>
    </div>
    <div v-if="$store.state.brandMoudle.activeName === '1'" class="header clearBoth">
      <span class="describe">The system searches for {{ $parent.$parent.result.enterprise.totalRecords }} results for you</span>
    </div>
    <ul class="dataList">
      <div v-loading="$parent.$parent.bool.enterpriseLoading">
        <li v-for="(item, index) in $parent.$parent.result.enterprise.pageData"
            v-if="$store.state.brandMoudle.activeName === '0' && index < 3" @click="toDetail(item)">
<!--          <div class="logoBgColor">
            <el-image class="picture"
                      v-if="item.logo"
                      :src="item.logo"
                      fit="contain">
            </el-image>
            <img v-else class="picture" :src="defaultLogo">
          </div>-->
          <div class="detail">
            <div class="detail-top">
              <span class="nameMark" v-html="titleInit(item.englishName)"></span>
              <span class="number">Number of articles：{{ item.count }}</span>
            </div>
            <div class="tag">
              <el-tag v-if="item.industry != null" color="#81d3f8">{{ item.industry }}</el-tag>
              <el-tag v-for="(value,index) in item.tags" v-if="item.tags.length>0" :key="index" color="#aff0b5"
                      style="color: #08b731">
                {{ value }}
              </el-tag>
            </div>
            <el-row class="description">
              <span>Establishment Date：{{ item.establishmentDate }}</span>
              <span>Registered Capital：{{ item.registeredCapital }}</span>
              <span>Stock exchange(s) listed：{{ item.stockListed }}</span>
              <span>Securities Code：{{ item.securitiesCode }}</span>
            </el-row>
            <el-row class="description">
              <span>Office Address：{{ item.officeAddress }}</span>
            </el-row>
          </div>
          <div class="btn">
            <el-button :class="!item.focusBtn ? 'focusBtn' : 'blurBtn'" size="mini" @click.stop="isFocus(item)">
              <i :class="[!item.focusBtn ? 'el-icon-plus': 'el-icon-check','icon-plus']"></i>Focus
            </el-button>
          </div>
        </li>
      </div>
      <div v-loading="$parent.$parent.bool.enterpriseLoading">
        <li v-for="(item, index) in $parent.$parent.result.enterprise.pageData" v-if="$store.state.brandMoudle.activeName === '1'"
            @click="toDetail(item)">
<!--          <div class="logoBgColor">
            <el-image class="picture"
                      v-if="item.logo"
                      :src="item.logo"
                      fit="contain">
            </el-image>
            <img v-else class="picture" :src="defaultLogo">
          </div>-->
          <div class="detail">
            <div class="detail-top">
              <span class="nameMark" v-html="titleInit(item.englishName)"></span>
              <span class="number">Number of articles：{{ item.count }}</span>
            </div>
            <div class="tag">
              <el-tag v-if="item.industry != null" color="#81d3f8">{{ item.industry }}</el-tag>
              <el-tag v-for="(value,index) in item.tags" v-if="item.tags.length>0" :key="index" color="#aff0b5"
                      style="color: #08b731">
                {{ value }}
              </el-tag>
            </div>
            <el-row class="description">
              <span>Establishment Date：{{ item.establishmentDate }}</span>
              <span>Registered Capital：{{ item.registeredCapital }}</span>
              <span>Stock exchange(s) listed：{{ item.stockListed }}</span>
              <span>Securities Code：{{ item.securitiesCode }}</span>
            </el-row>
            <el-row class="description">
              <span>Office Address：{{ item.officeAddress }}</span>
            </el-row>
          </div>
          <div class="btn">
            <el-button :class="!item.focusBtn ? 'focusBtn' : 'blurBtn'" size="mini" @click.stop="isFocus(item)">
              <i :class="[!item.focusBtn ? 'el-icon-plus': 'el-icon-check','icon-plus']"></i>Focus
            </el-button>
          </div>
        </li>
      </div>
    </ul>
    <el-pagination v-if="$store.state.brandMoudle.activeName === '1'" :current-page.sync="$parent.$parent.page.enterprise.page"
                   :page-size.sync="$parent.$parent.page.enterprise.size"
                   :total="$parent.$parent.result.enterprise.totalRecords"
                   background layout="total, prev, pager, next, jumper" @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"/>
  </div>
</template>
<script>
import request from '@/views/brand/utils/request.js'

export default {
  name: "enterprise",
  data() {
    return {
      defaultLogo: require("@/views/brand/assets/img/default-logo.png"),
      userFollow: {companyId: 0, companyName: ''},
    }
  },
  computed: {
    titleInit: function (title) {
      return function (title) {
        title = title.replaceAll(this.$store.state.brandMoudle.keywords, '<span style="color: #d9011c">' + this.$store.state.brandMoudle.keywords + '</span>');
        return title;
      }
    }
  },
  watch: {
    '$parent.$parent.activeName'() {
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    }
  },
  methods: {
    isFocus(index) {
      this.userFollow.companyId = index.companyId;
      this.userFollow.companyName = index.englishName;
      let params = JSON.parse(JSON.stringify(this.userFollow))
      if (index.focusBtn == true) {
        this.$confirm("Cancel the focus？", "提示", {type: "warning"}).then(() => {
          request({data: params, method: 'post', url: '/api/client/search/focus'}).then(result => {
            if (result.code == 200) {
              this.$message({message: 'success', type: 'success'})
              index.focusBtn = !index.focusBtn
            } /*else {
              this.$message({message: '操作失败', type: 'error'})
            }*/
          })
        }).catch(() => {
          // this.$message({type: "info", message: "已取消操作",});
        })
      } else {//新增关注
        request({data: params, method: 'post', url: '/api/client/search/focus'}).then(result => {
          if (result.code == 200) {
            this.$message({message: 'success', type: 'success'})
            index.focusBtn = !index.focusBtn
          } else {
            // this.$message({message: '关注失败', type: 'error'})
          }
        })
      }
    },
    toEnterprise() {
      this.$store.commit('setActiveName', '1')
    },
    toDetail(item) {
      this.$router.push({path: '/companyDetail', query: {uid: item.uid}});
    },
    handleSizeChange() {
      this.$parent.$parent.page.enterprise.page = 1
      this.$parent.$parent.getCompanyList()
    },
    handleCurrentChange() {
      this.$parent.$parent.getCompanyList()
    }
  }
}
</script>

<style scoped>
.header {
  border-bottom: 2px solid #ededed;
  padding-bottom: 20px;
  text-align: left;
}

.header .title {
  float: left;
  height: 50px;
  line-height: 50px;
  border-left: 12px solid #2f8eff;
  font-size: 18px;
  font-weight: bold;
  padding-left: 8px;
}

.header .amount {
  float: right;
  line-height: 50px;
  font-size: 14px;
  cursor: pointer;
  color: #AAAAAA;
}

.header .describe {
  font-size: 14px;
  font-weight: 400;
  color: #AAAAAA;
}

/*enterprise*/
.dataList div li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  padding: 24px 20px;
  border-bottom: 2px solid #e0e0e0;
  cursor: pointer;
}

.dataList div li:hover {
  background: #eeeeee;
}

.dataList div li img {
  /*max-height: 95px !important;
  min-width: 200px;
  max-width: 200px;*/
  width: 95px;
  height: 95px;
  border-radius: 10px;
  /*margin-right: 20px;*/
}

.dataList div li .description {
  font-size: 12px;
  margin-top: 10px;
}

.dataList div li .description span {
  margin-right: 20px;
  color: #303133;
}

.dataList .logoBgColor {
  margin-right: 30px;
}

.dataList .logoBgColor .picture {
  width: 95px;
  height: 95px;
}

.dataList div .detail {
  width: 100%;
  /*margin-left: 10px;*/
  text-align: left;
}

.dataList div .detail .tag {
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: left;
}

.dataList div .detail .detail-top .nameMark {
  color: #3a68b1;
  font-weight: bold;
  font-size: 16px;
  margin-right: 60px;
}

.dataList div .detail .detail-top .number {
  color: #aaaaaa;
  font-size: 12px;
}

.dataList div .btn .icon-plus {
  margin-right: 2px;
  font-weight: bold;
}

.dataList div .btn .focusBtn {
  border: 1px solid #2f8eff;
  color: #2f8eff;
}

.dataList div .btn .blurBtn.el-button {
  background: #ffffff;
  color: #aaaaaa;
}

.dataList div .el-button:focus, .el-button:hover {
  background: none;
}

.enterprise .el-pagination {
  margin-top: 20px;
}

.clearBoth:after {
  content: '';
  display: block;
  clear: both;
}

.enterprise {
  /*padding-top: 10px;*/
}
</style>
